(() => {
  const MOBILE_BREAKPOINT = 1020;

  function normalise(value) {
    return value
      .toLocaleLowerCase('de-CH')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function initialiseSidebar(sidebar) {
    if (sidebar.dataset.sidebarInitialised === 'true') return;
    sidebar.dataset.sidebarInitialised = 'true';

    const toggle = sidebar.querySelector('[data-sidebar-toggle]');
    const panel = sidebar.querySelector('[data-sidebar-panel]');
    const search = sidebar.querySelector('[data-sidebar-search]');
    const clearButton = sidebar.querySelector('[data-sidebar-search-clear]');
    const searchItems = Array.from(sidebar.querySelectorAll('[data-sidebar-search-item]'));
    const emptyState = sidebar.querySelector('[data-sidebar-empty]');
    const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

    function setPanelState(open) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    }

    function syncResponsiveState(event) {
      if (!toggle || !panel) return;
      setPanelState(!event.matches);
    }

    function updateSearch() {
      if (!search) return;
      const query = normalise(search.value);
      let visibleItems = 0;

      searchItems.forEach((item) => {
        const matches = !query || normalise(item.textContent).includes(query);
        item.hidden = !matches;

        if (matches) {
          visibleItems += 1;
          if (query) {
            const group = item.querySelector('details');
            if (group) group.open = true;
          }
        }
      });

      if (clearButton) clearButton.hidden = !query;
      if (emptyState) emptyState.hidden = visibleItems !== 0;
    }

    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        setPanelState(toggle.getAttribute('aria-expanded') !== 'true');
      });
      syncResponsiveState(mobileQuery);
      mobileQuery.addEventListener?.('change', syncResponsiveState);
    }

    if (search) {
      search.addEventListener('input', updateSearch);
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && search.value) {
          search.value = '';
          updateSearch();
        }
      });
    }

    if (clearButton && search) {
      clearButton.addEventListener('click', () => {
        search.value = '';
        updateSearch();
        search.focus();
      });
    }

    sidebar.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !mobileQuery.matches || !panel || panel.hidden) return;
      setPanelState(false);
      toggle?.focus();
    });
  }

  function initialiseAllSidebars(root = document) {
    root.querySelectorAll('[data-collection-sidebar]').forEach(initialiseSidebar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAllSidebars());
  } else {
    initialiseAllSidebars();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAllSidebars(event.target));
})();
